import { inject, Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { DiagnosisDto } from '@therapist/shared/models/diagnosis/diagnosis.dto';
import { Observable } from 'rxjs';
import { JointListItemDto } from '@therapist/shared/models/diagnosis/joint-list-item.dto';

@Injectable({providedIn: 'root'})
export class JointApiService {

  readonly #http = inject(HttpClient);

  private get endpoint() {
    return `${environment.basePath}/joint`;
  }

  getAll(): Observable<JointListItemDto[]> {
    return this.#http.get<JointListItemDto[]>(`${this.endpoint}`);
  }
}
